import moment from 'moment';

function objectToString(obj) {
  if (!obj) {
    return null;
  }
  let str = '';
  Object.keys(obj).forEach(t => {
    const item = obj[t];
    if (item) {
      if (str !== '') {
        str += ', ';
      }
      const obj = item[0].split('>');
      str += obj[obj.length - 1];
    }
  });
  return str;
};

function formatDate(val) {
  const isValidDate = moment(val).isValid();
  if (isValidDate) {
    return moment(val).format('MM/DD/YYYY');
  }
  return moment(parseInt(val)).format('MM/DD/YYYY');
};

export default {
  mapContent(item) {
    item.avg_rating = item.avg_rating ? parseFloat(item.avg_rating) : null;
    item.duration = item.duration ? parseInt(item.duration) : null;
    item.archived_date = item.archived_date ? formatDate(item.archived_date) : null;
    item.created = item.created ? formatDate(item.created) : null;
    item.production_date = item.production_date ? formatDate(item.production_date) : null;
    item.release_date = item.release_date ? formatDate(item.release_date) : null;
    item.sync_date = item.sync_date ? formatDate(item.sync_date) : null;
    item.imageSrc = `https://picsum.photos/1600/900?random=${item.syncguid}`;
    item.certification_authority = item.certification_authority ? item.certification_authority.join(', ') : null;
    item.certification_name = item.certification_name ? item.certification_name.join(', ') : null;
    item.content_features = item.content_features ? item.content_features.join(', ') : null;
    item.languages = item.languages ? item.languages.join(', ') : null;
    item.captions = item.captions ? item.captions.join(', ') : null;
    item.voiceover = item.voiceover ? item.voiceover.join(', ') : null;
    item.learning_path = item.learning_path ? item.learning_path.join(', ') : null;
    item.tags = item.tags ? item.tags.join(', ') : null;
    item.topic = objectToString(item.topic);
    item.skill = objectToString(item.skill);
    item.isCustom = item.content_type ? item.content_type === 'Custom' || item.content_type === 'Customized' : null;
    item.isELearning = item.content_type ? item.content_type === 'eLearning' : null;
    // isAICCOnly / isScormAndAiccOnly come from the API response (set by the
    // backend Content class — the single source of truth). Do not recompute here.
    item.parent_course_code = item.parent_course ? item.parent_course.code : null;

    return item;
  },
};
